export const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});
export const getRawBase64Data = async (file) => {
    try {
        let response = await toBase64(file);
        return response.substr(response.indexOf(',') + 1, response.length);
    } catch (error) {
        return null;
    }
};